import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import StatusCard from "@/components/autopilot/StatusCard";
import OptionsCard from "@/components/autopilot/OptionsCard";
import TopicList from "@/components/autopilot/TopicList";
import DraftList from "@/components/autopilot/DraftList";
import api, { errMsg } from "@/lib/api";
import { saveAutopilot } from "@/lib/autopilot";

export default function Autopilot() {
  const [cfg, setCfg] = useState(null);
  const [drafts, setDrafts] = useState([]);

  const reload = useCallback(() => {
    api.get("/autopilot").then((r) => setCfg(r.data)).catch(() => {});
    api.get("/autopilot/drafts").then((r) => setDrafts(r.data)).catch(() => {});
  }, []);
  useEffect(() => { reload(); }, [reload]);

  const save = async (patch, msg) => {
    try { const r = await saveAutopilot(patch); setCfg(r.data); toast.success(msg); return true; }
    catch (e) { toast.error(errMsg(e)); return false; }
  };

  return (
    <div>
      <PageHeader eyebrow="AI Autopilot" title="Bot AI post harian" desc="Isi produk/topik sekali sahaja. Setiap hari AI tulis post baharu, ubah ayat untuk setiap group dan jadualkan. Helper (Mod Latar Chrome) akan post sendiri." />
      {!cfg ? <Loader2 className="h-5 w-5 animate-spin text-primary" /> : (
        <div className="space-y-6">
          <StatusCard cfg={cfg} save={save} reload={reload} />
          {(cfg.mode === "approval" || drafts.length > 0) && <DraftList drafts={drafts} reload={reload} />}
          <div className="grid gap-6 lg:grid-cols-2">
            <TopicList cfg={cfg} save={save} />
            <OptionsCard cfg={cfg} save={save} />
          </div>
        </div>
      )}
    </div>
  );
}
